import React, { useRef } from "react";
import ProgressDot from "./ProgressDot";

const ProgressDotGroup = ({
  totalSteps,
  currentStep,
  isReviewed = false,
  listAnwserErr = [],
  listQuestion = [],
  questAnswers = {},
  submittedSteps = [],
  isValidationReceipt = true,
}) => {
  const scrollContainerRef = useRef(null);
  const questionCount = listQuestion.length;
  const effectiveTotalSteps = listQuestion.length || totalSteps;
  const answerErrSteps = listAnwserErr.map((err) => err.step_index);

  const maxVisibleDots = 10;
  const stepOffset = isValidationReceipt ? 2 : 1;
  const displayIndex = Math.max(0, currentStep - stepOffset);

  let windowStart = 0;

  if (effectiveTotalSteps > maxVisibleDots) {
    windowStart = displayIndex - 2;

    if (windowStart < 0) {
      windowStart = 0;
    }

    const maxStart = effectiveTotalSteps - maxVisibleDots;
    if (windowStart > maxStart) {
      windowStart = maxStart;
    }
  }

  const windowEnd = Math.min(
    windowStart + maxVisibleDots - 1,
    effectiveTotalSteps - 1
  );

  return (
    <div className="flex flex-col items-center w-full">
      <div className="text-sm font-medium text-gray-500 mb-2">
        {isValidationReceipt
          ? currentStep === 1
            ? "Upload Receipt"
            : `${currentStep - 1} of ${questionCount}`
          : `${currentStep} of ${questionCount}`}
      </div>

      <div
        ref={scrollContainerRef}
        className="flex items-center gap-2 overflow-x-auto no-scrollbar w-full px-2 py-2 justify-center"
        style={{ scrollBehavior: "smooth" }}
      >
        {Array.from(
          { length: windowEnd - windowStart + 1 },
          (_, visibleIdx) => {
            const index = windowStart + visibleIdx;
            const actualStep = index + stepOffset;
            const questionId = listQuestion[index]?.id;
            const isErrorStep =
              isReviewed && answerErrSteps.includes(actualStep);
            const hasAnswer =
              submittedSteps.includes(actualStep - 1) ||
              !!questAnswers[questionId];
            const isActive = currentStep === actualStep;

            return (
              <ProgressDot
                key={`dot-question-${index}`}
                index={index}
                isActive={isActive}
                currentStep={currentStep}
                isReviewed={isReviewed}
                isErrorStep={isErrorStep}
                hasAnswer={hasAnswer}
                onClick={() => {}}
              />
            );
          }
        )}
      </div>
    </div>
  );
};

export default ProgressDotGroup;